import { CopyrightPlacement, FeedFormat } from "../types";

declare const sgSettings: any;

interface ICopyrightConfig {
  message: string;
  placement: CopyrightPlacement;
}

const copyrightData: Record<FeedFormat, CopyrightPlacement> = {
  [FeedFormat.CN2I_HANNEQUART]: CopyrightPlacement.WELCOME,
  [FeedFormat.GERMAN_ARROW_WORD]: CopyrightPlacement.WELCOME,
  [FeedFormat.LAROUSSE]: CopyrightPlacement.BOARD,
  [FeedFormat.REACH]: CopyrightPlacement.WELCOME,
  [FeedFormat.REACH_BAUER]: CopyrightPlacement.WELCOME,
  [FeedFormat.TCA]: CopyrightPlacement.WELCOME,
  [FeedFormat.TCA_MINI]: CopyrightPlacement.WELCOME,
  [FeedFormat.HEARST]: CopyrightPlacement.WELCOME,
};

export function getCopyrightData(format: FeedFormat): ICopyrightConfig {
  const placement = copyrightData[format];
  return {
    placement,
    message: getCopyrightMessage(),
  };
}

function getCopyrightMessage(): string {
  return (
    // sgSettings &&
    sgSettings.config &&
    sgSettings.config.crossword &&
    sgSettings.config.crossword.customisation &&
    sgSettings.config.crossword.customisation.copyright
  ) || "";
}
